export const RUN_QUERY = 'RUN_QUERY';
export const UPDATE_LAYOUT_ADVANCED_SEARCH = 'UPDATE_LAYOUT_ADVANCED_SEARCH';
export const CLEAR_COLUMNS_QUERY = 'CLEAR_COLUMNS_QUERY';
export const CLEAR_QUERY = 'CLEAR_QUERY';
export const EXPORT_QUERY = 'EXPORT_QUERY';
export const SAVE_QUERY = 'SAVE_QUERY';
export const SHARE_QUERY = 'SHARE_QUERY';
export const DISABLED_EXPORT_QUERY = 'DISABLED_EXPORT_QUERY';
export const DISABLED_SAVE_QUERY = 'DISABLED_SAVE_QUERY';
export const DISABLED_RUN_QUERY = 'DISABLED_RUN_QUERY';
export const EDIT_QUERY = 'EDIT_QUERY';
export const CANCEL_QUERY = 'CANCEL_QUERY';
